var _path, _path2, _line, _line2, _line3, _line4, _line5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReadDocOnline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.2 20H5.0665C4.4775 20 4 19.5225 4 18.9335V5.0665C4 4.4775 4.4775 4 5.0665 4H12.625C12.908 4 13.18 4.1125 13.38 4.313L17.5545 8.488C17.7545 8.688 17.8665 8.9595 17.8665 9.2425V12.5335",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5335 4V8.2665C12.5335 8.856 13.011 9.3335 13.6 9.3335H17.8665C17.8665 9.3335 17.8665 18.2751 17.8665 19C17.8665 19.7249 17.7189 19.9977 17 20H7",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 9.5,
    x2: 11,
    y2: 9.5,
    stroke: "black"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 7.5,
    x2: 11,
    y2: 7.5,
    stroke: "black"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 11.5,
    x2: 16,
    y2: 11.5,
    stroke: "black"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 13.5,
    x2: 16,
    y2: 13.5,
    stroke: "black"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 15.5,
    x2: 16,
    y2: 15.5,
    stroke: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReadDocOnline);
export default __webpack_public_path__ + "static/media/read-doc-online.d31a83d9b63af40b5412315cd93b5863.svg";
export { ForwardRef as ReactComponent };